<div class="dashboard">
    <div class="headerBg">
    </div>

    <div class="sectionsHolder">
        <div class="section">
            <app-dashboard-accounts *ngIf="section == 'accounts' && subSection == 'requests'  "></app-dashboard-accounts>

            <app-dashboard-all-accounts *ngIf="section == 'accounts' && subSection == 'all' "></app-dashboard-all-accounts>
            
            <app-dashboard-deleted-accounts *ngIf="section == 'accounts' && subSection == 'deleted' "></app-dashboard-deleted-accounts> 

            <app-dashboard-booking-requests *ngIf="section == 'bookings' && subSection == 'requests' "></app-dashboard-booking-requests>

            <app-dashboard-booking-confirmed *ngIf="section == 'bookings' && subSection == 'approved' " ></app-dashboard-booking-confirmed>

            <app-dashboard-booking-denied *ngIf="section == 'bookings' && subSection == 'denied' "></app-dashboard-booking-denied>

            <app-dashboard-booking-past *ngIf="section == 'bookings' && subSection == 'past-bookings' "></app-dashboard-booking-past>
        </div>

    </div>
</div>

<app-dashboard-booking-overlay *ngIf="bookingService.isDashBookingOpen"></app-dashboard-booking-overlay>

<app-dashboard-delete-overlay  *ngIf="authService.deleteOverlayOpen"></app-dashboard-delete-overlay>